import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import { useRouter } from "next/router";

//Style
import Styles from "./ContinueSignup.module.scss";

//Components
import Typography from "@vahak/core-ui/dist/components/Typography";

// Icons
import AngleRightOrange from "@vahak/core/dist/icons/AngelRightOrange.svg";
import COLORS from "@vahak/core-ui/dist/constants/colors";
import { AppContext } from "@vahak/core/dist/app-context";
import { GA4EventNames } from "@vahak/core/dist/constants/event-names";
import { useEventTrackerService } from "@vahak/core/dist/_services/hooks/useEventTrackerService";

const ContinueSignup = () => {
    const router = useRouter();
    const { isPhoneVerified, companyId, userId } = useContext(AppContext);
    const [hideSignUpBanner, setHideSignUpBanner] = useState(true);
    const { sendGAandMoEngageEvent } = useEventTrackerService();

    const handleClick = () => {
        sendGAandMoEngageEvent({
            name: GA4EventNames.COMPANY_REGISTRATION.continue_signup_banner,
            data: { userId }
        });
        router.push({ hash: "#Login" });
    };

    useEffect(() => {
        if (!isPhoneVerified || companyId) {
            setHideSignUpBanner(true);
        } else {
            setHideSignUpBanner(false);
        }
    }, [isPhoneVerified, companyId]);

    if (hideSignUpBanner) return <></>;
    return (
        <div className={classnames(Styles.main)}>
            <div className={classnames(Styles.wrapper, "container")}>
                <Typography size="m" mSize="s" as="p" align="center">
                    Complete the company registration
                </Typography>
                <div className={Styles.actionBtn} onClick={handleClick}>
                    <Typography size="m" mSize="s" as="p" color={COLORS.ORANGE_500} underline>
                        Continue SignUp <AngleRightOrange />
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default ContinueSignup;
